import { THIS_EXPR } from '@angular/compiler/src/output/output_ast';
import { Component } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, Router, RouterOutlet } from '@angular/router';
import { Observable, Subject } from 'rxjs';
import { Configuration } from './constants/configuration';
import { AvatarHelper } from './login/helpers/avatar-helper';
import { ClienteHelper } from './login/helpers/cliente-helper';
import { B2CAspecto, B2CAspectoMaker } from './models/B2CAspecto.model';
import { B2CContenido, B2CContenidoMaker } from './models/B2CContenido.model';
import { B2CPortalProducto, B2CPortalProductoMaker } from './models/B2CPortalProducto.model';
import { Color, ColorMaker } from './models/color.model';
import { Contratante } from './models/contratante.model';
import { Fondo, FondoMaker } from './models/fondo.model';
import { Logo, LogoMaker } from './models/logo.model';
import { Pie, PieMaker } from './models/pie.model';
import { QuattroB2C } from './models/quattroB2C.model';
import { routeTransitionEstructura } from './route-transition-animations';
import { RequestServices } from './services/request.service';
import { dataStorage, StorageService } from './services/storage.service';
import { StorageEnum } from './utilities/storage.enum';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
  animations: [routeTransitionEstructura]
})
export class AppComponent {
  private subject = new Subject<any>();
  public contratante = new Contratante();
  public quattroB2C: QuattroB2C = new QuattroB2C();

  constructor(private storageService: StorageService, private requestService: RequestServices, private router: Router, private route: ActivatedRoute, private titleService: Title) {
    this.getCodeGoogle();
    this.getTitleAndFavicon();
    if (!this.storageService.ifExist("quattroB2C")) {
      let quattroB2C: QuattroB2C = new QuattroB2C();
      this.storageService.setItem("quattroB2C", JSON.stringify(quattroB2C));
      this.storageService.setItem("d", "805/Y+YHzUW3cfBi53XTwtkzgOcbQ+VhFbMbjMdeYJaQNmvG5wra25L/4ml97TC6");
      this.storageService.setItem("b", "6zGLknMcsetJhwUrln4LahPCqD2n+Ce9xw3LOnfk6mw=");
    }
  }
  private observableStorage: any;
  ngOnInit() {
    this.observableStorage = this.storageService.watchSessionStorage().subscribe((data: dataStorage) => {
      switch (data.accion) {
        case StorageEnum.removeAll:
          this.getEstructuraAspecto();
          break;
      }
    });
    this.validateRequestParams();
    this.getEstructuraAspecto();
  }

  ngAfterViewInit(): void {
    if (window.location.hostname == 'prevex.tupoliza.mx') {
      this.setClientifyScriptCode();
    }
  }

  prepareRoute(outlet: RouterOutlet): boolean {
    return outlet && outlet.activatedRouteData && outlet.activatedRouteData['animationState'];
  }

  validateRequestParams() {
    try {
      this.route.queryParams.subscribe(params => {
        if (params?.target && params?.tkn && params?.d && params?.clienteEnc && params?.socioEnc) {
          if (params.target == 'micuenta') {
            this.requestService.getRequest({ projectName: new Configuration().QUATTRO_OAUTH_SERVICE_URL, apiName: 'auth/validate', params: { "token": params.tkn } }).subscribe(
              result => {
                if (result.valid) {
                  // generar vars en sessionStorage
                  this.storageService.setItem('tkn', params.tkn);
                  this.storageService.setItem('d', params.d);
                  this.storageService.setItem("usr", result.payload.data.user);
                  this.storageService.setItem("accessedFromQuattroCRM", params.socioEnc);

                  if (this.storageService.ifExist('quattroB2C')) {
                    this.quattroB2C = JSON.parse(this.storageService.getItem("quattroB2C"));
                  }

                  this.contratante.clienteIDEnc = params.clienteEnc;
                  this.storageService.setItem("isLogged", "true");
                  this.quattroB2C.contratante = this.contratante;
                  this.quattroB2C.socioEnc = params.socioEnc;
                  this.storageService.setItem('quattroB2C', JSON.stringify(this.quattroB2C));
                  new ClienteHelper(this.requestService, this.storageService, this.quattroB2C, this.contratante).getCliente().subscribe(result => {
                    if (result) {
                      // redirect
                      this.router.navigate(['micuenta']);
                    }
                  });
                  new AvatarHelper(this.requestService, this.storageService, this.quattroB2C, this.contratante).getAvatar();

                } else {
                  // token expirado
                  this.router.navigate(['principal']);
                }
              },
              error => {
                this.router.navigate(['principal']);
              }
            );
          }
        }
      });
    } catch (error) {

    }
  }

  getEstructuraAspecto() {
    try {
      this.requestService.getRequest({ projectName: new Configuration().API_B2C, apiName: 'b2c/publics/boot-config', params: [{ "dominio": new Configuration().getDominio() }] }).subscribe(
        result => {
          if (result.error) {
            console.error(result.error)
          } else {
            this.subject.next(result.result.b2cAspectoDTO);
            if (this.storageService.ifExist("quattroB2C")) {
              let quattroB2C: QuattroB2C = JSON.parse(this.storageService.getItem('quattroB2C'));
              quattroB2C.socioEnc = sessionStorage.getItem('accessedFromQuattroCRM') || result.result.socioEnc;
              quattroB2C.b2cPortalID = result.result.portalEnc;
              this.storageService.setItem("quattroB2C", JSON.stringify(quattroB2C));
              this.getParametrosPortal(quattroB2C.b2cPortalID);
            } else {
              let quattroB2C: QuattroB2C = new QuattroB2C();
              quattroB2C.socioEnc = result.result.socioEnc;
              quattroB2C.b2cPortalID = result.result.portalEnc;
              this.storageService.setItem("quattroB2C", JSON.stringify(quattroB2C));
              this.getParametrosPortal(quattroB2C.b2cPortalID);
            }

            if (!this.storageService.ifExist("d")) {
              this.storageService.setItem("d", "O042n0ATXIqpGCm8zbJ1RTP0SyQtMtaAyBtTE/uQrEtU6D8rEV9O2muBXQ4ueICqWKPkNKdnw0PByn5EwFOG1g==");
            }
            if (!this.storageService.ifExist("b")) {
              this.storageService.setItem("b", "6zGLknMcsetJhwUrln4LahPCqD2n+Ce9xw3LOnfk6mw=");
            }

            let logoModel: Logo = LogoMaker.createInterface({
              normalUrl: result.result.b2cAspectoDTO.logo.normalUrl,
              medianoUrl: result.result.b2cAspectoDTO.logo.medianoUrl
            });
            let colorModel: Color = ColorMaker.createInterface({
              primario: result.result.b2cAspectoDTO.color.primario, secundario: result.result.b2cAspectoDTO.color.secundario, terciario: result.result.b2cAspectoDTO.color.terciario, textoPrimario: result.result.b2cAspectoDTO.color.textoPrimario, textoSecundario: result.result.b2cAspectoDTO.color.textoSecundario
            });
            let fondoModel: Fondo = FondoMaker.createInterface({
              imagen: result.result.b2cAspectoDTO.fondo.imagen,
              alineacion: result.result.b2cAspectoDTO.fondo.alineacion,
              color: result.result.b2cAspectoDTO.fondo.color
            });
            let pieModel: Pie = PieMaker.createInterface({
              contenidoPrimario: result.result.b2cAspectoDTO.pie.contenidoPrimario,
              contenidoSecundario: result.result.b2cAspectoDTO.pie.contenidoSecundario,
              colorTexto: result.result.b2cAspectoDTO.pie.colorTexto,
              colorPrimario: result.result.b2cAspectoDTO.pie.colorPrimario,
              colorSecundario: result.result.b2cAspectoDTO.pie.colorSecundario
            });
            let contenidoModel: B2CContenido = B2CContenidoMaker.createInterface({
              portalHtml: result.result.b2cAspectoDTO.b2cContenido.portadaHtml,
              portalScript: result.result.b2cAspectoDTO.b2cContenido.portadaScript,
              portalStyle: result.result.b2cAspectoDTO.b2cContenido.portadaStyle
            });
            let portalProductoModel: any = result.result.b2cAspectoDTO.b2cPortalProducto;

            let B2CAspecto: B2CAspecto = B2CAspectoMaker.createInterface({ logo: logoModel, color: colorModel, fondo: fondoModel, pie: pieModel, contenido: contenidoModel, portalProducto: portalProductoModel });
            this.storageService.setItem("B2CAspecto", JSON.stringify(B2CAspecto));
          }
        }, error => {
          console.error(error.message);
        }
      );

    } catch (error) {

      console.error("error", error);
    }
  }

  getCodeGoogle() {
    let codeTagManager: string = "";
    switch (window.location.hostname) {
      case "aycia.tupoliza.mx":
      //case "localhost":
        codeTagManager = "GTM-WQMTVVT";
        break;
      case "certy.trinitas.mx":
        codeTagManager = "G-9LD7RWY9Q3";
        break;
      case "prevex.tupoliza.mx":
        codeTagManager = "GTM-TP4NB5R";
        break;
      case "servicios.raspberry.mx":
        codeTagManager = "GTM-NFCLLPGL";
        break;
      default:
        break;
    }
    if (codeTagManager !== "") {
      this.setCodeGoogleTagManager(codeTagManager);
    }
  }

  getTitleAndFavicon() {
    let favicon: string = "./assets/icos/head/";
    switch (window.location.hostname) {
      case "prevex.tupoliza.mx":
        this.setFaviconAndTitle(favicon.concat("prevex.ico"), "Prevex - Cotiza");
        break;
      default:
        this.setFaviconAndTitle("favicon.ico", "QuattroB2c");
        break;
    }
  }

  setCodeGoogleTagManager(code: string) {
    let script = document.createElement('script');
    script.append("(function (w, d, s, l, i) {");
    script.append("w[l] = w[l] || []; w[l].push({");
    script.append("'gtm.start':");
    script.append("new Date().getTime(), event: 'gtm.js'");
    script.append("}); var f = d.getElementsByTagName(s)[0],");
    script.append("j = d.createElement(s), dl = l != 'dataLayer' ? '&l=' + l : ''; j.async = true; j.src =");
    script.append("'https://www.googletagmanager.com/gtm.js?id=' + i + dl; f.parentNode.insertBefore(j, f);");
    script.append("})(window, document, 'script', 'dataLayer', '" + code + "');");
    document.head.appendChild(script);

    let noscript = document.createElement('noscript');
    noscript.innerHTML = "<iframe src=\"https://www.googletagmanager.com/ns.html?id=" + code + "\" height=\"0\" width=\"0\" style=\"display:none;visibility:hidden\"></iframe>";
    document.body.appendChild(noscript);
  }

  setClientifyScriptCode() {
    let script = document.createElement('script');
    script.src = "https://api.clientify.net/web-marketing/webforms/external/script/136297.js";
    script.type = "text/javascript";
    document.head.appendChild(script);
    document.body.appendChild(script);
  }
  
  setFaviconAndTitle(favicon: string, title: string) {
    let link = document.getElementById('favB2c');
    link?.setAttribute("href", favicon);

    this.titleService.setTitle(title);
  }

  private getParametrosPortal(b2cPortalID: string): void {
    const params = {
      b2cPortalID,
      parametroID: [ 10, 16, 19 ]
    };
    this.requestService.getRequest({ projectName: new Configuration().API_B2C, apiName: 'b2c/publics/portal-parametro', params }).subscribe({
      next: response => {
        if (response.ok) {
          const quattroB2C: QuattroB2C = JSON.parse(this.storageService.getItem('quattroB2C'));
          quattroB2C.portalParametros = response.result;
          this.storageService.setItem("quattroB2C", JSON.stringify(quattroB2C));
        }
      }
    });
  }
}